<nb-card class="mb-0 no-edge-card full-height-modal">
  <nb-card-body>
    <div class="selection-container">
      <h1 class="selection-title">{{ 'MENUACTIONS.TITLESTUDENT' | translate }}:</h1>

      <div class="options-grid">
        <button class="option-card" nbTooltip="{{ 'MENUACTIONS.EN_CLASE' | translate }}"
          nbTooltipPlacement="top" (click)="enClase()">
          <div class="option-image-wrapper">
            <img src="../../../../../assets/images/control-panel/formacion.png" alt="Icono de clase con profesor" />
          </div>
					<span class="option-text texto-pequeno">{{ 'MENUACTIONS.EN_CLASE' | translate }}</span>
        </button>

        <button class="option-card" nbTooltip="{{ 'MENUACTIONS.ESTUDIANDO' | translate }}" nbTooltipPlacement="top"
          (click)="estudiando()">
          <div class="option-image-wrapper">
            <img src="../../../../../assets/images/control-panel/educacion-en-el-hogar.png" alt="Icono de persona estudiando" />
          </div>
					<span class="option-text texto-pequeno">{{ 'MENUACTIONS.ESTUDIANDO' | translate }}</span>
        </button>
      </div>

    </div>
  </nb-card-body>
</nb-card>
